import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../InputT';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const Tab5 = (props: { form?: any }) => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState([])
  const navigate = useNavigate()


  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));




  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  try {
    let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
    form.setFieldsValue((localData.form))

  } catch (error) {

  }
  if (pageLoad) {
    try {
      let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
      //form.setFieldsValue((localData.form))
      let tab = localData.data as []

      tab.pop()
      tab.pop()

      setData(tab)
      //console.log(data)
      setPageLoad(false)
      SetStart()
      setImpActive(false)

    } catch (error) {

    }
  }

  const columns: ColumnsType<any> = [
    {
      title: 'N° Séq',
      dataIndex: 'numSeq',
    },
    {
      title: 'Date Echéance',
      dataIndex: 'dateEcheacnce',
    },
    {
      title: 'Capital (C)',
      dataIndex: 'capital',
    },
    {
      title: 'Amortiss (A)',
      dataIndex: 'amortissement',
    },
    // {
    //   title: 'Echéancier',
    //   dataIndex: 'echeancierSansTaxe',
    // },
    {
      title: 'Inttérets (I)',
      dataIndex: 'interet',
    },
    {
      title: 'Taxes (T)',
      dataIndex: 'taxe',
    },
    {
      title: 'Epargne (E)',
      dataIndex: 'epargne',
    },
    {
      title: 'AHT (A+I) ',
      dataIndex: 'anHT',
    },
    {
      title: 'ATTC (AHT+I) ',
      dataIndex: 'anTTC',
    }
  ];

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    setImpActive(true)
    setData([])
    props.form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }



  const affiche = () => {
    try {
      let values: Pret = props.form.getFieldsValue()
      //localStorage.clear()

      setImpActive(false)

      let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, ReformatNumber(values.MONTAN+""), values.TYPCALC, values.TAUXTAX, ReformatDate(values.DAT1ECHE), values.MTNCOM1 + values.MTNCOM2 + values.MTNCOM3 + values.MTNCOM4 + values.MTNCOM5)
      //console.log(JSON.stringify(Amort.GetAmortissement()))

      setData(Amort.GetAmortissement() as [])

      props.form.setFieldsValue(Amortissement.totaux)
    } catch (error) {
      console.log(error)
    }

  };

  setTimeout(() => {
    try {
      let load = localStorage.getItem(Data.LocalVariable.loadPret)
      if (load == "1") {
        affiche()
        localStorage.removeItem(Data.LocalVariable.loadPret);
      }
    } catch (error) {
    }
    try {
      let reset = localStorage.getItem(Data.LocalVariable.reset)
      if (reset == "1") {
        setData([])
      }
      localStorage.removeItem(Data.LocalVariable.reset)
    }
    catch (error) {
      console.log(error)
    }
  }, .1)


  // const onFinishFailed = async (errorInfo: any) => {
  //   var errors: any = [];

  //   errorInfo.errorFields.map((error: any) => {

  //     errors.push(error.name + "");
  //   })

  //   SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  // };


  // function printTab() {
  //   var newData = []
  //   newData = data as any

  //   newData.push({
  //     "numSeq": "",
  //     "dateEcheacnce": "",
  //     "capital": "",
  //     "amortissement": "",
  //     "interet": "",
  //     "taxe": "",
  //     "epargne": "",
  //     "anHT": "",
  //     "anTTC": ""
  //   })
  //   newData.push({
  //     "numSeq": "TOTAL ",
  //     "dateEcheacnce": "",
  //     "capital": "",
  //     "amortissement": Amortissement.totaux.TotAm,
  //     "interet": Amortissement.totaux.TotIt,
  //     "taxe": Amortissement.totaux.TotTaxe,
  //     "epargne": Amortissement.totaux.TotEpargn,
  //     "anHT": Amortissement.totaux.TotAnnuite,
  //     "anTTC": Amortissement.totaux.TotAnTTC,
  //   })
  //   localStorage.setItem(Data.LocalVariable.tabAmort, JSON.stringify({ "columns": columns, "data": newData, "form": form.getFieldsValue() }))

  //   navigate("/prets/simulation/print")
  // }

  // const onFinish = (values: any) => {
  //   if (sbmit == "add") {
  //     SweetAlert.fire({
  //       title: "Enregistrement de la simulation de pret",
  //       text: "Voulez-vous enregistrer cette simulation de crédit?",
  //       showCancelButton: true,
  //       color: "green",
  //       confirmButtonText: "Yes",
  //       confirmButtonColor: "green",
  //       cancelButtonColor: "darkred",
  //       cancelButtonText: "No",
  //       showLoaderOnConfirm: true,
  //       icon: 'question'
  //     }).then((res) => {
  //       if (res.isConfirmed) {
  //         setLoading(true);
  //         setIsSubmit(true)
  //         //alert(JSON.stringify(values))

  //         let pret: Pret = values
  //         pret.UTILISAI = user.coduti
  //         pret.AGCCPT = user.codage
  //         pret.DATEDEM = formatDate(pret.DAT1ECHE)
  //         pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
  //         pret.NOMCLI = values.lib_NUMCLI
  //         pret.fraiservi = values.cssionApliq
  //         //alert(pret.NOMCLI)
  //         let data = Crypter.encrypt(JSON.stringify(pret));

  //         let config = {
  //           method: 'post',
  //           maxBodyLength: Infinity,
  //           url: Data.ApiUrl.CreateTab5Pret,
  //           headers: {
  //             //'CypherUser': data,
  //             'Authorization': authHeader(),
  //             'Content-Type': 'application/json'
  //           },
  //           data: data
  //         };

  //         axios.request(config)
  //           .then((response) => {
  //             setLoading(false);
  //             if (response.data) {
  //               const res = JSON.parse(Crypter.decrypt(response.data)).Value;

  //               if (res.StatutCode == 200) {
  //                 let code = values.CODUTI
  //                 form.resetFields()
  //                 localStorage.clear()
  //                 setIsSubmit(false)
  //                 SweetAlert.fire({ title: res.Message, icon: "success" })
  //                 initialiazeButton()
  //                 localStorage.setItem(Data.LocalVariable.reset, "1")

  //                 setSbmit("")
  //               }
  //               else {
  //                 SweetAlert.fire({ title: res.Message, icon: "warning" })
  //               }
  //             }
  //           })
  //           .catch((error) => {
  //             setLoading(false);
  //             console.log(error)
  //             SweetAlert.fire({ title: error, icon: "error" })
  //           });

  //       }
  //     })
  //   }
  //   if (sbmit == "update") {
  //     //console.log(values)
  //     SweetAlert.fire({
  //       title: "Voulez-vous modifier la demande de pret " + values.NUMDOS + " ?",
  //       showCancelButton: true,
  //       color: "green",
  //       confirmButtonText: "Yes",
  //       confirmButtonColor: "green",
  //       cancelButtonColor: "darkred",
  //       cancelButtonText: "No",
  //       showLoaderOnConfirm: true,
  //       icon: 'question'
  //     }).then((res) => {
  //       if (res.isConfirmed) {
  //         setLoading(true);
  //         setIsSubmit(true)

  //         let data = Crypter.encrypt(JSON.stringify(values));

  //         let config = {
  //           method: 'put',
  //           maxBodyLength: Infinity,
  //           url: Data.ApiUrl.UpdateTab5Pret,
  //           headers: {
  //             //'CypherUser': data,
  //             'Authorization': authHeader(),
  //             'Content-Type': 'application/json'
  //           },
  //           data: data
  //         };

  //         axios.request(config)
  //           .then((response) => {
  //             setLoading(false);
  //             if (response.data) {
  //               const res = JSON.parse(Crypter.decrypt(response.data)).Value;

  //               if (res.StatutCode == 200) {
  //                 let code = values.CODUTI
  //                 form.resetFields()
  //                 localStorage.clear()
  //                 setIsSubmit(false)
  //                 SweetAlert.fire({ title: res.Message, icon: "success" })
  //                 initialiazeButton()
  //                 localStorage.setItem(Data.LocalVariable.reset, "1")

  //                 setSbmit("")
  //               }
  //               else {
  //                 SweetAlert.fire({ title: res.Message, icon: "warning" })
  //               }
  //             }
  //           })
  //           .catch((error) => {
  //             setLoading(false);
  //             console.log(error)
  //             SweetAlert.fire({ title: error, icon: "error" })
  //           });
  //       }
  //     })
  //   }
  // };
  // function modif() {
  //   modifButton()

  // }

  // function consult() {
  //   localStorage.setItem(Data.LocalVariable.reset, "1")
  //   //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
  //   let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
  //   let NUMSIMUL = form.getFieldValue("NUMSIMUL")

  //   if (data.length != 0) {
  //     initialiazeButton()
  //     setLoading(true)
  //     form.resetFields()
  //     form.setFieldValue('NUMSIMUL', NUMSIMUL)
  //     let config = {
  //       method: 'get',
  //       maxBodyLength: Infinity,
  //       url: Data.ApiUrl.GetTab5Pret,
  //       headers: {
  //         'CypherNumSimul': data,
  //         'Authorization': authHeader(),
  //         'Content-Type': 'application/json'
  //       },
  //     };
  //     axios.request(config)
  //       .then((response) => {
  //         setLoading(false);
  //         if (response.data) {
  //           const res = JSON.parse(Crypter.decrypt(response.data)).Value;

  //           console.log(res)
  //           if (res.StatutCode == 200) {
  //             form.setFieldsValue(res.Result.Table[0])
  //             form.setFieldValue('DATEDEM', ReformatDate(values.DATEDEM));
  //             form.setFieldValue('DAT1ECHE', ReformatDate(values.DAT1ECHE));
  //             //form.setFieldValue('', )

  //             localStorage.clear()

  //             //alert(JSON.stringify(res.Result.Table))

  //             initialiazeButton()

  //             cunsultButton()
  //             setEnregActve(false)


  //           }
  //           else {
  //             SweetAlert.fire({ title: res.Message, icon: "warning" })
  //           }
  //         }
  //         setLoading(false)
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.log(error)
  //         SweetAlert.fire({ title: error, icon: "error" })
  //       });
  //   }
  // }

  return (

    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
          <div className='clientP'>
            <div >
              <Box position={"relative"} display={"flex"} fontStyle="inherit" width={"99%"} className='border-left tabElement'>
                <Spin spinning={loading}>
                  <Table size='small' style={{ width: 'auto' }} columns={columns} dataSource={data} scroll={{ y: 220, x: 10 }} pagination={false} />
                </Spin>
                <Box display={"flex"} width={"98%"} marginTop={"5%"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
                  <InputForm notRequired disabled width={8} label='Amort' name='TotAm' type='text' error='mobile' />
                  <InputForm notRequired disabled width={8} label='Intéret' name='TotIt' type='text' error='mobile' />
                  <InputForm notRequired disabled width={8} label='TVA' name='TotTaxe' type='text' error='mobile' />
                  <InputForm notRequired disabled width={8} label='AHT' name='TotAnnuite' type='text' error='mobile' />
                  <InputForm notRequired disabled width={8} label='ATTC' name='TotAnTTC' type='text' error='mobile' />
                  <InputForm notRequired disabled width={8} label='Epargne' name='TotEpargn' type='text' error='mobile' />
                </Box>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  )
}
export default Tab5;